/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionChangesControllerFindOneQueryResponse, QuestionChangesControllerFindOnePathParams, QuestionChangesControllerFindOneQueryParams, QuestionChangesControllerFindOne400, QuestionChangesControllerFindOne401, QuestionChangesControllerFindOne403, QuestionChangesControllerFindOne404 } from "../../models/checklistsController/QuestionChangesControllerFindOne";

function getQuestionChangesControllerFindOneUrl(id: QuestionChangesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-question-changes/${id}` as const }  
  return res
}

/**
 * @summary Get a specific question change flag by ID
 * {@link /api/v1/checklist-question-changes/:id}
 */
export async function questionChangesControllerFindOne(id: QuestionChangesControllerFindOnePathParams["id"], params?: QuestionChangesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<QuestionChangesControllerFindOneQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindOne400 | QuestionChangesControllerFindOne401 | QuestionChangesControllerFindOne403 | QuestionChangesControllerFindOne404>, unknown>({ method : "GET", url : getQuestionChangesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}